import ebayLogo from "../../assets/marketplaces/ebay.svg";
import shopifyLogo from "../../assets/marketplaces/shopify.svg";
import depopLogo from "../../assets/marketplaces/depop.svg";
import vintedLogo from "../../assets/marketplaces/vinted.svg";
import poshmarkLogo from "../../assets/marketplaces/poshmark.svg";

export const blurMessages = [
  "Analyzing image...",
  "Detecting image sharpness...",
  "Checking focus & clarity...",
];

export const autoFillMessages = [
  "Analyze image",
  "Get the product details",
  "Authentication",
  "Condition",
  "Generating description",
];

export const poshmarkSubCategoriesMap = {
  Women: [
    "Accessories",
    "Bags",
    "Dresses",
    "Intimates & Sleepwear",
    "Jackets & Coats",
    "Jeans",
    "Jewelry",
    "Makeup",
    "Pants & Jumpsuits",
    "Shoes",
    "Shorts",
    "Skirts",
    "Sweaters",
    "Swim",
    "Tops",
    "Skincare",
    "Hair",
    "Bath & Body",
    "Global & Traditional Wear",
  ],
  Men: [
    "Accessories",
    "Jackets & Coats",
    "Jeans",
    "Pants",
    "Shirts",
    "Shoes",
    "Shorts",
    "Suits & Blazers",
    "Sweaters",
    "Swim",
    "Underwear & Socks",
    "Grooming",
    "Global & Traditional Wear",
    "Other",
  ],
  Kids: [
    "Accessories",
    "Bottoms",
    "Dresses",
    "Jackets & Coats",
    "Matching Sets",
    "One Pieces",
    "Pajamas",
    "Shirts & Tops",
    "Shoes",
    "Swim",
    "Costumes",
    "Bath, Skin & Hair",
    "Toys",
    "Other",
  ],
  Home: ["Furniture", "Decor", "Kitchen"],
  Pets: ["Food", "Toys", "Clothes"],
  Electronics: ["Mobiles", "Laptops", "Accessories"],
};

export const conditions = [
  { value: "new", label: "New" },
  { value: "like-new", label: "Like New" },
  { value: "excellent", label: "Excellent" },
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
  { value: "poor", label: "Poor" },
];

export const marketplaces = [
  { id: "ebay", name: "eBay", logo: ebayLogo },
  { id: "shopify", name: "Shopify", logo: shopifyLogo },
  { id: "poshmark", name: "Poshmark", logo: poshmarkLogo },
  { id: "vinted", name: "Vinted", logo: vintedLogo },
  { id: "depop", name: "Depop", logo: depopLogo },
];

export const availableMarketplaces = [
  { id: "ebay", name: "eBay", logo: ebayLogo },
  { id: "shopify", name: "Shopify", logo: shopifyLogo },
  { id: "poshmark", name: "Poshmark", logo: poshmarkLogo },
  { id: "vinted", name: "Vinted", logo: vintedLogo },
];

export const upcomingMarketplaces = [
  { id: "depop", name: "Depop", logo: depopLogo },
];

export const steps = [
  { id: 1, title: "Image Upload" },
  { id: 2, title: "Listing Details" },
  { id: 3, title: "Marketplaces" },
  { id: 4, title: "Image Processing" },
  { id: 5, title: "Review" },
];

